import { SituationFeatureCollection } from "./models/SituationFeatureCollection";

export type TrafficMessageConfig = {
    URL: string
}

export const trafficMessageConfig : TrafficMessageConfig = {
    URL: process.env.REACT_APP_TRAFFIC_MESSAGE_URL_PROD as string
};

export async function getTrafficMessages(){
    const promise = await fetch(trafficMessageConfig.URL);
    const data = await promise.json() as SituationFeatureCollection;

    return data;
}
